import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export const useSettingStore = create(
  persist(
    (set, get) => ({
      billModeByBrId: {},

      // เก็บล่าสุดไว้กัน brId หลุด (ไม่มี default)
      last: { brId: null, billMode: null },

      getBillMode: (brId) => {
        const state = get();

        if (brId === undefined || brId === null) {
          return state.last?.billMode ?? null;
        }

        const key = String(brId);

        if (Object.prototype.hasOwnProperty.call(state.billModeByBrId, key)) {
          return state.billModeByBrId[key];
        }

        if (state.last?.brId === brId) {
          return state.last.billMode;
        }

        return null;
      },

      /**
       * ❗ set เฉพาะค่าที่มาจาก API เท่านั้น
       * - รับเฉพาะ 0 หรือ 1
       * - ค่าอื่น ignore
       */
      setBillMode: (brId, v) =>
        set((s) => {
          if (v !== 0 && v !== 1) return s; // ❌ ignore ค่าไม่ valid

          const key = String(brId);

          return {
            billModeByBrId: {
              ...(s.billModeByBrId || {}),
              [key]: v,
            },
            last: { brId, billMode: v },
          };
        }),

      resetBr: (brId) =>
        set((s) => {
          const next = { ...(s.billModeByBrId || {}) };
          delete next[String(brId)];
          return { billModeByBrId: next };
        }),

      resetAll: () =>
        set({
          billModeByBrId: {},
          last: { brId: null, billMode: null },
        }),
    }),
    {
      name: "app_setting",
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ billModeByBrId: s.billModeByBrId, last: s.last }),
    }
  )
);
